import { render, staticRenderFns } from "./OrganizationRolesTable.vue?vue&type=template&id=424cbe66&scoped=true"
import script from "./OrganizationRolesTable.vue?vue&type=script&lang=js"
export * from "./OrganizationRolesTable.vue?vue&type=script&lang=js"
import style0 from "./OrganizationRolesTable.vue?vue&type=style&index=0&id=424cbe66&prod&lang=css"
import style1 from "./OrganizationRolesTable.vue?vue&type=style&index=1&id=424cbe66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424cbe66",
  null
  
)

export default component.exports